export default{
    service:'خدمت',
    services:'خدمات',
    serviceCategory: 'نوع خدمت',
    serviceProperty: 'ویژگی خدمت',
    serviceTitle: 'عنوان',
    serviceCode: 'کد',
    action: 'عملیات',
    editService:'ویرایش خدمات',
    addService:'واحد پول جدید',
    newServices:'خدمات جدید',
    discountGroup: 'گروه‌های تخفیف',
    serviceGroups: 'دسته بندی های آزمایش',
    serviceGender: 'جنسیت خدمت ',
    searchServiceByCategory: 'جستجو براساس نوع خدمت',
    searchByCode: 'جستجو براساس کد',

}